import useReduxAction from '@hooks/useReduxAction'

function useTemplateQualityControlCategories(options: { performHttpRequests: boolean }) {
  const { performHttpRequests } = options

  // @ts-expect-error TS2339
  const { data: templateQualityControlCategories } = useReduxAction(
    'taskListTemplates',
    'loadTemplateQualityControlCategories',
    {},
    [],
    {
      shouldPerformFn: () => performHttpRequests,
    },
  )

  return {
    templateQualityControlCategories,
  }
}

export default useTemplateQualityControlCategories
